import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const CheckYellowBackground = (props: IconProps) => (
  <IconBase fill="none" {...props}>
    <path
      d="M13.5128 4.83105C14.6173 4.83105 15.5128 5.72649 15.5128 6.83105L15.5128 17.9136C15.5128 18.8459 14.757 19.6017 13.8247 19.6017H2.43027C1.49797 19.6017 0.742188 18.8459 0.742188 17.9136V6.51914C0.742188 5.58683 1.49797 4.83105 2.43027 4.83105H9.00669"
      fill="#F8D472"
    />
    <path
      d="M4.5 9.06926C5.16317 9.6465 5.57342 10.0963 6.28861 11.1388C7.00379 12.1812 7.68136 13.7964 8.56562 15.4087C9.89406 12.6887 11.2525 7.42536 17.2868 1.83691"
      stroke="#2A2A2A"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export default CheckYellowBackground;
